export default {
  'openEndedQuestion.title': 'Açık Uçlu Soru',
  'openEndedQuestion.crateTitle': 'Açık Uçlu Soru Oluştur',
  'openEndedQuestion.duplicateTitle': 'Açık Uçlu Soru Çoğalt',
  'openEndedQuestion.questionContentTitle': 'Soru İçeriği',
  'openEndedQuestion.questionContentSubtitle': 'Sorunun içeriğini hazırlayın',
  'openEndedQuestion.expectedAnswer': 'Beklenen Yanıt',
};
